<template>
  <div class="">
    <v-card class="no-shadow">
      <v-card-title class="ctn_search">
        Lectura masiva - {{getPeriod}}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <!-- {{ getLoadTable }} -->
      <v-data-table
        :headers="getHeader"
        :items="getListDeviceSucess"
        :loading="getLoadTable"
        :sort-by="['idx']"
        :sort-desc="[true]"
        loading-text="Cargando información …."
        :search="search"
      >
        <template v-slot:[`header.name`]="{ header }">
          {{ header.text.toUpperCase() }}
        </template>

        <template v-slot:[`item.activate`]="{ item }">
          <div class="lb lb_activo" v-if="item.activate == 1">Activo</div>
          <div class="lb lb_inactivo" v-else>
            <span class="span_inactive">Inactivo</span>
          </div>
        </template>
        <template v-slot:[`item.switch`]="{ item }">
          <div class="lb " v-if="item.switch === true">
            <span class="lbs sw_active">Encendido</span>
          </div>
          <div class="lb" v-else>
            <span class="lbs sw_inactive">Apagado</span>
          </div>
        </template>
        <template v-slot:[`item.lastData`]="{ item }">
          <div class="ctn_lasdata">
            <p v-if="item.lastData != null" class="ctn_lasdata_date">
              {{ item.lastData.createdAt | formatDateFrom }}
            </p>
            <p class="ctn_lasdata_item">
              <span v-if="item.lastData != null">
                {{ item.lastData.valUsage.toFixed(2).toString().replace('.',',') }} {{ item.lastData.unitValUsage }}</span
              >
              <span v-else class="none"> - </span>
            </p>
          </div>
        </template>
        <template v-slot:[`item.profile`]="{ item }">
          <div v-if="item.profile == 'post'">
            Postpago
          </div>
          <div v-else>
            Prepago
          </div>
        </template>
        <template v-slot:[`item.sucess`]="{}">
          <div class="lb ">
            <span class="lbs sw_active">Exitosa</span>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="table_menu"
                color="primary"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="list_action">
                <v-btn class="cent" @click="takeItem(item)" plain
                  >Lectura</v-btn
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <TakeRead
      :data="itemObjct"
      :visible="TakeFlag"
      :isMassive="true"
      @close="TakeFlag = false"
    ></TakeRead>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import TakeRead from '@/components/device/TakeRead.vue'
export default {
  name: 'TableReviewComp',
  components: {
    TakeRead,
  },
  data() {
    return {
      search: '',
      flagTable: true,
      EditFlag: false,
      TakeFlag: false,
      ConnectFlag: false,
      itemObjct: {},
      headerMaster: [
        { text: 'Estado', value: 'activate' },
        { text: 'IDX', value: 'idx' },
        { text: 'Switch', value: 'switch' },
        { text: 'NUI', value: 'nui', align: 'start' },
        { text: 'Tipo', value: 'subTypeService' },
        { text: 'Perfil', value: 'profile' },
        { text: 'Lectura tomada', value: 'lastData', sortable: false },
        { text: 'Serial', value: 'serial', align: ' d-none' },
        { text: 'Usuario', value: 'user', align: ' d-none' },
        { text: 'Comunicación', value: 'sucess' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      headersClient: [
        { text: 'Estado', value: 'activate' },
        { text: 'Switch', value: 'switch' },
        { text: 'NUI', value: 'nui', align: 'start' },
        { text: 'Tipo', value: 'subTypeService' },
        { text: 'Perfil', value: 'profile' },
        { text: 'Lectura tomada', value: 'lastData', sortable: false },
        { text: 'Comunicación', value: 'sucess' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    }
  },
  async mounted() {
    //await this.listDevice()
    this.$root.$on('reload', async () => {
      await this.getListDeviceSucess
    })
  },

  methods: {
    ...mapActions(['listDevice']),
    takeItem(param) {
      this.itemObjct = Object.assign({}, param)
      this.TakeFlag = true
    },
  },
  computed: {
    ...mapGetters(['getListDeviceSucess', 'isMaster']),
    getLoadTable() {
      if (this.getListDeviceSucess.length > 0) {
        return false
      }
      return true
    },
    getHeader() {
      if (this.isMaster == 1) {
        return this.headerMaster
      }
      return this.headersClient
    },
    getPeriod() {
      if(this.getListDeviceSucess.length > 0) {
        return this.getListDeviceSucess[0].lastData.period.name;
      }
      return '';
    }
  },
  filters: {
    getTakeReadDate(array) {
      if (array.length > 0 && array != undefined && array != null) {
        let filter = array.slice(-1)
        return filter[0].dateNow
      }
      return '-'
    },
    getTakeRead(array) {
      if (array.length > 0 && array != undefined && array != null) {
        let filter = array.slice(-1)
        return filter[0].usage
      }
      return '-'
    },
    formatDateFrom: (value) => {
      if (value) {
        return moment(value)
          .locale('es')
          .fromNow()
      }
      return '-'
    },
    formatDateShort: (value) => {
      if (value) {
        return moment(value)
          .locale('es')
          .format('LL')
      }
      return '-'
    },
    formatDate: (value) => {
      if (value) {
        return moment(value)
          .locale('es')
          .format('LLL')
      }
      return '-'
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/scss/base.scss';
.ctn_lasdata {
  p {
    margin: 0;
    &.ctn_lasdata_date {
      font-weight: 600;
      font-size: 0.8rem;
      margin-bottom: 0;
    }
    &.ctn_lasdata_item {
      span {
        border-radius: 4px;
        padding: 1px 5px;
        background-color: $dark-jungle-green;
        color: $light-cyan;
        &.none {
          color: $color-text-grey;
          background-color: transparent;
        }
      }
    }
  }
}
.table_menu {
  background-color: hsl(120deg 100% 25% / 4%);
}
.span_inactive {
  color: $alert;
}
.list_action {
  padding: 0 2px;
  &:last-child {
    button:hover,
    a:hover {
      background-color: $alert;
    }
  }
  a,
  button {
    color: $color-text;
    text-decoration: none;
    display: block;
    font-size: 0.9rem;
    padding: 6px 16px;
    border-radius: 2px;
    &.cent {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    width: 100%;
    &:hover {
      color: #fff;
      background-color: $color-link;
    }
  }
  span {
    font-size: 0.9rem;
  }
}
span.lbs {
  border-radius: 4px;
  font-size: 0.75rem;
  margin: 2px;
  &.sw_active {
    color: #fff;
    padding: 5px 10px;
    background-color: $bag-green;
  }
  &.sw_inactive {
    padding: 5px 10px;
    background-color: $alert;
    color: #fff;
  }
}
i.i-con {
  font-size: 0.8rem !important;
  &.off {
    color: $alert;
  }
  &.on {
    color: $green-btn;
  }
}
</style>
